"use_strict"

const $ = require('zepto-browserify').$;

class Carousel {

	/**
	 * @param {Node} carousel
	 */
	constructor ( carousel ) {
		this._carousel      = carousel;
		this._buttonPrev    = document.querySelector('#carousel-previous');
		this._buttonNext    = document.querySelector('#carousel-next');

		// If there's more than one slide, the div.owl-carousel is present
		if ( document.querySelector('.owl-carousel') ) {
			this._initCarousel();
		}
	}

	/**
	 * @function _initCarousel
	 * @desc Initialize the current carousel
	 */
	_initCarousel () {
		let $carousel = $(this._carousel)

		$carousel.owlCarousel({
			loop: true,
			items: 1,
			dotsContainer: '#carousel-nav-list',
			// autoplay: true,
			autoplaySpeed: 1500,
			onInitialized: function () {
				document.querySelector('.carousel').classList.add('loaded');
			}
		});

		if (this._buttonPrev && this._buttonNext) {
			this._bindUIActions();
		}
	}

	/**
	 * @function _bindUIActions
	 * @desc Add event listener to the buttons of the carousel
	 */
	_bindUIActions () {
		let $carousel = $(this._carousel)

		this._buttonPrev.addEventListener('click', () => {
			$carousel.trigger('prev.owl.carousel', 500)
		});

		this._buttonNext.addEventListener('click', () => {
			$carousel.trigger('next.owl.carousel', 500)
		});
	}
}

export { Carousel }
